var reportStatusesSelect = 
[
    {
        code: "U",
        //title: "modal.caseReport.label.unresolved",
        title: "Unresolved"
    },
    {
        code: "F",
        //title: "modal.caseReport.label.flagged",
        title: "Flagged"
    },
    {
        code: "RP",
        //title: "modal.caseReport.label.flagged",
        //title: "Resolved - Proceed"
        title: "Cleared"
    },
    {
        code: "RE",
        //title: "modal.caseReport.label.flagged",
        title: "Cleared - Enhanced"
    },
    {
        code: "RD",
        //title: "modal.caseReport.label.flagged",
        title: "Match Confirmed"
    }
];

var reportStatusesFilterView = [
    ...reportStatusesSelect,
    {
        code: "RN",
        //title: "modal.caseReport.label.flagged",
        title: "Resolved - No Matches"
    }
];

export {reportStatusesSelect, reportStatusesFilterView}